export type SickNoteStep = {
	title: string;
	detail?: string;
};

// The sick-note form and the dashboard read this one list, so the two titles cannot drift apart.
// The form shows the detail of a step. The dashboard shows the titles only.
export const sickNoteSteps: SickNoteStep[] = [
	{
		title: "Vor Arbeitsbeginn: Info an Suse & Ragna.",
		detail: "Bei Krankschreibung: Meldung der genauen Daten (von...bis...)",
	},
	{
		title: "Info an Projektleitung / Projektteam und Kunde",
		detail: "(gemäß Absprache im Projekt)",
	},
	{
		title: "Abwesenheit in Outlook Kalender eintragen",
		detail: "Idealerweise / falls möglich: Termine aktiv absagen",
	},
];
